import { render, staticRenderFns } from "./flightRoutesXML.vue?vue&type=template&id=0bfae9b8&scoped=true&"
import script from "./flightRoutesXML.vue?vue&type=script&lang=ts&"
export * from "./flightRoutesXML.vue?vue&type=script&lang=ts&"
import style0 from "./flightRoutesXML.vue?vue&type=style&index=0&id=0bfae9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfae9b8",
  null
  
)

export default component.exports